import { DatePicker, Form, Input, Select } from "antd";
import { useLoaderData, useRouteLoaderData } from "react-router";
import dayjs from "dayjs";
import SimpleFormPage from "../common/SimpleFormPage";
import { filterOption, requiredField } from "../common/common";
import { useEffect, useState } from "react";
import { api } from "../common/api";

export default function VehicleSetupForm() {
  const setup = useRouteLoaderData("setup");
  const [types, setTypes] = useState([]);
  useEffect(() => {
    api.setupType.list({ pageSize: 9999 }).then(({ data }) => setTypes(data));
  }, []);

  return (
    <SimpleFormPage
      title={setup ? "Modifica allestimento" : "Nuovo allestimento"}
      loadFn={
        setup
          ? (form) =>
              form.setFieldsValue({
                model: setup.model,
                type: setup.type.id,
                firstInspectionDate: setup.firstInspectionDate,
              })
          : undefined
      }
    >
      <Form.Item name="model" label="Modello">
        <Input />
      </Form.Item>
      <Form.Item name="type" label="Categoria" rules={[requiredField]}>
        <Select
          showSearch
          filterOption={filterOption}
          options={types.map((type) => ({ label: type.description, value: type.id }))}
        />
      </Form.Item>
      <Form.Item
        name="firstInspectionDate"
        label="Data ultima ispezione (oppure data di acquisto)"
        getValueProps={(value) => ({ value: value ? dayjs(value) : null })}
        normalize={(value) => (value ? value.format("YYYY-MM-DD") : null)}
      >
        <DatePicker format="DD-MM-YYYY" style={{ width: "100%" }} />
      </Form.Item>
    </SimpleFormPage>
  );
}
